var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.501,
    viewBox: "0 0 20 20.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_copy",
    "data-name": "filter copy",
    d: "M19.138,0H.861A.859.859,0,0,0,.1.466a.871.871,0,0,0,.068.906l6.7,9.433.007.01a1.912,1.912,0,0,1,.376,1.135v7.69A.855.855,0,0,0,8.1,20.5a.881.881,0,0,0,.337-.068L12.2,19a.815.815,0,0,0,.561-.8V11.95a1.913,1.913,0,0,1,.375-1.135l.007-.01,6.7-9.433A.87.87,0,0,0,19.9.466.858.858,0,0,0,19.138,0Zm0,0",
    transform: "translate(0.001 0)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.876e8e2fe2d4de97d6708fd8bcc6785d.svg";
export { ForwardRef as ReactComponent };